import WebsiteBehaviors from "../website-behaviors/index.js";

class APAPsycNET extends WebsiteBehaviors {
	identifier() {
		return "APAPsycNET";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "psycnet.apa.org");
	}

	initialRenderDelay() {
		return 6000; // This site seems to need a bit more time
	}
}

export default APAPsycNET;
